var map = {
	"./Bundle.svg": "be2a",
	"./Burger.svg": "0112",
	"./Coffee.svg": "5cf2",
	"./CreditCard.svg": "609c",
	"./Deal.svg": "8d70",
	"./Drink.svg": "045f",
	"./Family.svg": "e16d",
	"./Grocery.svg": "d79b",
	"./HealthyMeal.svg": "9882",
	"./Insurance.svg": "c699",
	"./MobilePay.svg": "4cec",
	"./Netflix.svg": "2448",
	"./One.svg": "9f1a",
	"./Pets.svg": "ef6a",
	"./Platform.svg": "605f",
	"./Reward.svg": "75de",
	"./Saving.svg": "ba1d",
	"./Taxi.svg": "0675",
	"./Walk.svg": "a6e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e809";